export default "__VITE_ASSET__DSmhzkbx__"